var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.model.css, style: _vm.model.style }, [
    _c(
      "div",
      { staticClass: "sv-header__cell-content", style: _vm.model.contentStyle },
      [
        _vm.model.showLogo
          ? _c("div", { staticClass: "sv-header__logo" }, [
              _c("div", { class: _vm.model.survey.logoClassNames }, [
                _c("img", {
                  class: _vm.model.survey.css.logoImage,
                  style: {
                    objectFit: _vm.model.survey.logoFit,
                    width: _vm.model.survey.renderedStyleLogoWidth,
                    height: _vm.model.survey.renderedStyleLogoHeight,
                  },
                  attrs: {
                    src: _vm.model.survey.locLogo.renderedHtml,
                    width: _vm.model.survey.renderedLogoWidth,
                    height: _vm.model.survey.renderedLogoHeight,
                    alt: _vm.model.survey.locTitle.renderedHtml,
                  },
                }),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.model.showTitle
          ? _c(
              "div",
              {
                staticClass: "sv-header__title",
                style: { maxWidth: _vm.model.textAreaWidth },
              },
              [
                _c("survey-element-title", {
                  attrs: {
                    element: _vm.model.survey,
                    css: _vm.model.survey.css,
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.model.showDescription
          ? _c(
              "div",
              {
                staticClass: "sv-header__description",
                style: { maxWidth: _vm.model.textAreaWidth },
              },
              [
                _vm.model.survey.renderedHasDescription
                  ? _c(
                      "div",
                      { class: _vm.model.survey.css.description },
                      [
                        _c("survey-string", {
                          attrs: { locString: _vm.model.survey.locDescription },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            )
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }